import script from "./FooterHome.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterHome.vue?vue&type=script&setup=true&lang=js"

import "./FooterHome.vue?vue&type=style&index=0&id=0a2a0e26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2a0e26"]])

export default __exports__